import { useEffect } from "react";
import { useOutletContext } from "react-router";
import AuthorizationDetail from "./AuthorizationDetail";
import AuthorizationDetailEdit from "./AuthorizationDetailEdit";

const Authorization = () => {
  const {
    setBreadcrumbs,
    templateInfo,
    isEditing,
    formAuthorization,
    editedFormAuthorization,
    setEditedFormAuthorization,
    groups,
    isNew,
    translate,
  } = useOutletContext();

  useEffect(() => {
    if (templateInfo) {
      setBreadcrumbs([
        {
          id: 0,
          title: "page_titles.form-templates",
          route: "auth.formTemplates",
        },
        { id: 1, customTitle: templateInfo?.name || "" },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateInfo]);

  return (
    <>
      {isEditing || isNew ? (
        <AuthorizationDetailEdit
          formAuthorization={editedFormAuthorization}
          setFormAuthorization={setEditedFormAuthorization}
          translate={translate}
          groups={groups}
        />
      ) : (
        <AuthorizationDetail
          formAuthorization={formAuthorization}
          translate={translate}
          groups={groups}
        />
      )}
    </>
  );
};
export default Authorization;
